module.exports = __webpack_public_path__ + "img/ourServiceBackgroundTop.3f406490.svg";